var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin"},[_c('admin-header'),_c('div',{staticClass:"body"},[_c('side-bar'),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }